module.exports = __webpack_public_path__ + "1bf36ef01759ab41e7589b959d9a3bda.svg";